import { render } from "./ShowPDF.vue?vue&type=template&id=93fe70bc&scoped=true"
import script from "./ShowPDF.vue?vue&type=script&lang=js"
export * from "./ShowPDF.vue?vue&type=script&lang=js"

import "./ShowPDF.vue?vue&type=style&index=0&id=93fe70bc&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93fe70bc"]])

export default __exports__